module.exports = __webpack_public_path__ + "img/homepage-grey.b63d5b7a.svg";